import loadable from '@react-loadable/revised';
import LoadingComponent from 'common/loader';
import type { ApplicationRoute } from 'routes/routes';

const routes: ApplicationRoute[] = [
    {
        path: '/notifications/inbox',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/InboxPage').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
];
export default routes;
